export default "__VITE_ASSET__BhbCDQqL__"